import { createAction } from 'redux-act';

const Actions = {};

Actions.showModule = createAction('set module to be visible', moduleId => ({ moduleId }));
Actions.hideModule = createAction('set module to be hidden', moduleId => ({ moduleId }));

export default Actions;
